import { EventEmitter } from '@angular/core';
import { AssetConfig } from './asset-management/asset-config.interface';
import { ILookup } from '../shared/lookup';
export class ClearanceItem {
    id: string;
    name: string;
    createdDate: string;
    artistAuthorName: string;
    copyrightInfo: string;
    deadline: string;
    description: string;
    isCreatedByProd: Boolean;
    projectId: string;
    projectName: string;    
    refUrl: string;
    ciUniqueId:string;
    scene: string;
    episode: string;
    season: string;
    status: string;
    tags: CITag[];
    uiTags: CITag[];
    selectedTags: CITag[];
    documents: CIDocument[];
    defaultImage: CIImage;
    images: CIImage[]
    imagesRef: CIImage[]
    restrictions: CIRestriction[];
    isSelected:boolean;
    statusChangeComments:string;
    reportGroupName: string;
    titles:ILookup[];
    hasNotes:boolean;
    hasCINotes:boolean;
    unreadNotesCount:number;
    fonts: string;
    statusClass: string;
    constructor(){
        this.status = "NEW";
        this.tags = [];
        this.uiTags = [];
        this.selectedTags = [];
        this.documents = [];
        this.images = [];
        this.imagesRef = [];
        this.restrictions = [];
    }
}
export class CITag {
    id: string;
    tagName: string;
    tagId: string;
    tagType: string;
    cIId: string;
    icon: string;
    isSelected:boolean;
}

export class CIAsset implements AssetConfig{
    type: string;
    enlargeImageEvent: EventEmitter<any>;
    id: string;
    name: string;
    urlName: string;
    fullUrl: string;
    url: string;    
    fileType: string;
    loading: boolean;
    assetType: string;
    cIId: string;
    defaultC: boolean;
    showOnReports: boolean;
    savedId: string;
    downloading: boolean=false;   
    originalImageFullUrl: string; 
    order: number = 0;
    highlighted: boolean = false;
    font: string;
    usage: string;
    tag: string;
    notes: string;
    comments: string;
    originalCIImageId: string;
    lastModifiedDate: Date;
    createdDate: Date;
    relatedImages: CIImage[];
    originalFullUrl: string;
    thumbnailFullUrl: string;
    mediumImageFullUrl: string;
}

export class CIDocument extends CIAsset{
    dMNumber: string;
    cIId: string;
    savedId: string;    
    loading: boolean;
}
export class CIImage extends CIAsset {
    cIId: string;
    defaultC: boolean;
    showOnReports: boolean;
    loading: boolean;
    savedId: string;
    downloading: boolean=false;
    originalImageFullUrl: string;
    originalCIImageId: string;
    lastModifiedDate: Date;
    createdDate: Date;
    relatedImages: CIImage[];
    originalFullUrl: string;
    thumbnailFullUrl: string;
    mediumImageFullUrl: string;
}

export class AssetId {
    icon: string;
    label: string;
}

export class CIRestriction {
    id: string;
    restrictionType: string;
    description: string;
    cIId: string;
    isSelected:boolean;
    pinned:boolean;
}
export class CISignedUrl{
    name: string;
    url: string;
}
export class ListSearchData{
	 projectId:string;
	 sortBy:string;
	 sortOrder:string;
	 status:string;
	filterBy:string;
	 filterString:string;
	 pazesize:number;
	 pageStartIndex:number;
	totalNumberOfRecords:number;
    allRecords:boolean;
	hasNotes:boolean;
	hasUnreadNotes:boolean;
	resultSet:ClearanceItem[];
  }
  export class MassUpdateData{
		updateType:string;
	    clearanceItems:string[];
   		status:string;
		projectId:string;
		statusChangeComments:string;
		tags:CITag[];
        documents:CIDocument[];
        images:CIImage[];
        groupName:string;
   }

   export class ItemHistory{
       id: string;
       field: string;
       oldValue: string;
       newValue: string;
       author: string;
       created: String;
       createdTime: String;
   }